// Static content for Mark Wilson Construction site
// NOTE: project partner names and square footage are PLACEHOLDER values — please replace
// with verified data before publishing externally.

export const COMPANY = {
    name: "Mark Wilson Construction",
    short: "MWC",
    founded: 1997,
    location: "Fresno, CA",
    region: "San Joaquin Valley",
    tagline: "LISTEN. PLAN. BUILD.",
    phone: "(559) 348-0421",
    email: "connect@markwilsonconstruction.com",
    contact_name: "Daniel Tovar",
    address: "5799 E Clinton Ave, Fresno, CA 93727",
};

// 3 clickable stat boxes
export const STATS = [
    { value: "8", label: "Delivery Methods", href: "/services" },
    { value: "7", label: "Market Sectors", href: "/projects" },
    { value: "1997", label: "Founded", href: "/about" },
];

export const THREE_CS = [
    {
        letter: "C",
        title: "Connect",
        body: "We listen to understand who you are, what you're building, and what success looks like for your organization.",
    },
    {
        letter: "C",
        title: "Communicate",
        body: "Open and transparent communication — or \"telling the kind truth\" — not only keeps us aligned but allows for better decision making throughout the project.",
    },
    {
        letter: "C",
        title: "Collaborate",
        body: "Solving problems together, aligning goals, and building trust through shared ownership of project success.",
    },
];

export const FOUR_PILLARS = [
    {
        n: "01",
        title: "Safety",
        body: "Safety of our staff and yours is paramount. Our definition extends beyond jobsite hazards to creating an environment where people feel safe being transparent, discussing concerns, and approaching challenges together.",
    },
    {
        n: "02",
        title: "Quality",
        body: "Quality construction is a standard, but quality relationships are equally important. We believe both are necessary to achieve successful outcomes.",
    },
    {
        n: "03",
        title: "Time",
        body: "Meeting milestones is critical to project success. The time spent together during preconstruction has a profound impact on the overall outcome of a project.",
    },
    {
        n: "04",
        title: "Cost",
        body: "Budget and cost matter, but so does measuring the value of relationships, communication, and meeting expectations throughout the project.",
    },
];

// Preconstruction services — each with a "So What?" outcome
export const PRECON_SERVICES = [
    { title: "Constructability Review", outcome: "Identify conflicts before construction begins." },
    { title: "Estimate Development", outcome: "Set a budget the team can actually deliver against." },
    { title: "Value Engineering", outcome: "Reduce costs while protecting quality." },
    { title: "Schedule Development", outcome: "Sequence the work to hit critical milestones." },
    { title: "Project Advertising", outcome: "Increase bid participation and subcontractor interest." },
    { title: "Safety Analysis", outcome: "Address risk before the first crew arrives." },
    { title: "Logistical Planning", outcome: "Minimize disruptions and improve project efficiency." },
    { title: "LEAN Construction", outcome: "Production management-based approach." },
];

export const CONSTRUCTION_SERVICES = [
    "Site Logistics",
    "Weekly Pre-Installation Meetings",
    "Safety Reviews",
    "Construction Supervision",
    "Daily Reports",
    "Clash Detection & Coordination",
];

export const DELIVERY_METHODS = [
    "Hard Bid",
    "Select Bid",
    "CM Multiple Prime",
    "CM-at-Risk",
    "Lease — Lease Back",
    "Negotiated Sum",
    "Cost Plus Fee",
    "Design Build",
];

export const SECTORS = [
    { slug: "educational", name: "Educational" },
    { slug: "industrial", name: "Industrial" },
    { slug: "law-fire", name: "Law Enforcement & Fire" },
    { slug: "medical", name: "Medical" },
    { slug: "office-retail", name: "Office & Retail" },
    { slug: "religious", name: "Religious" },
    { slug: "university", name: "University & College" },
    { slug: "nonprofit", name: "Nonprofit" },
];

// 12 featured projects (rotated periodically). Hover reveals: description, partner, sq ft.
// Each project includes 2 images for fade transition on hover.
export const FEATURED_PROJECTS = [
    {
        id: "riverstone-elementary",
        name: "Stone Creek Elementary School",
        sector: "educational",
        sectorLabel: "Educational",
        partner: "Golden Valley Unified",
        architect: "SIM/PBK",
        sqft: "67,000 sq. ft.",
        description: "Ground-up TK–6 campus for Golden Valley USD with flexible classroom pods, media commons, multi-purpose room, and full sports facilities spanning 14 acres.",
        images: [
            "/img/projects/stonecreek-01.jpg",
            "/img/projects/stonecreek-06.jpg",
            "/img/projects/stonecreek-02.jpg",
            "/img/projects/stonecreek-08.jpg",
            "/img/projects/stonecreek-07.jpg",
            "/img/projects/stonecreek-11.jpg",
            "/img/projects/stonecreek-09.jpg",
            "/img/projects/stonecreek-10.jpg",
            "/img/projects/stonecreek-03.jpg",
            "/img/projects/stonecreek-04.jpg",
            "/img/projects/stonecreek-05.jpg",
        ],
    },
    {
        id: "canyon-creek-elementary",
        name: "Canyon Creek Elementary School",
        sector: "educational",
        sectorLabel: "Educational",
        partner: "Golden Valley Unified School District",
        architect: "Teter LLP",
        sqft: "65,000 sq. ft.",
        description: "New construction of eight-building elementary school campus encompassing approximately 65,000 square feet of building space across a 16-acre site.",
        images: [
            "/img/projects/canyon-creek-01.webp",
            "/img/projects/canyon-creek-02.webp",
            "/img/projects/canyon-creek-03.webp",
            "/img/projects/canyon-creek-04.webp",
            "/img/projects/canyon-creek-05.webp",
        ],
    },
    {
        id: "garza-aquatics",
        name: "Justin Garza HS — Aquatics",
        sector: "educational",
        sectorLabel: "Educational",
        partner: "Central Unified",
        architect: "PBK",
        sqft: "—",
        description: "New construction of the Aquatics Complex including an Olympic-size Myrtha pool, diving pool, locker rooms, snack bar, coach offices, and storage buildings.",
        images: [
            "/img/projects/garza-aquatics-01.webp",
            "/img/projects/garza-aquatics-02.webp",
            "/img/projects/garza-aquatics-03.webp",
        ],
    },
    {
        id: "garza-playfields",
        name: "Justin Garza HS — Playfields",
        sector: "educational",
        sectorLabel: "Educational",
        partner: "Central Unified",
        architect: "PBK",
        sqft: "—",
        description: "New Playfield Complex including JV and Varsity baseball and softball fields.",
        images: [
            "/img/projects/garza-playfields-01.webp",
        ],
    },
    {
        id: "clovis-west-diesel-cte",
        name: "Clovis West Diesel CTE",
        sector: "educational",
        sectorLabel: "Educational",
        partner: "Clovis Unified School District",
        architect: "Teter",
        sqft: "—",
        description: "New Diesel repair facility and classroom designed for hands-on diesel mechanics training.",
        images: [
            "/img/projects/cte-01.jpg",
            "/img/projects/cte-02.jpg",
            "/img/projects/cte-03.jpg",
            "/img/projects/cte-04.jpg",
            "/img/projects/cte-05.jpg",
            "/img/projects/cte-06.jpg",
            "/img/projects/cte-07.jpg",
            "/img/projects/cte-08.jpg",
            "/img/projects/cte-09.jpg",
            "/img/projects/cte-10.jpg",
        ],
    },
    {
        id: "cusd-do-phase-1",
        name: "CUSD District Office — Phase 1",
        sector: "educational",
        sectorLabel: "Educational",
        partner: "Clovis Unified School District",
        architect: "Teter",
        sqft: "—",
        description: "Multi-building campus for Clovis Unified featuring the Clovis Online School and administrative offices — with modern classrooms, reception, and shared community space.",
        images: [
            "/img/projects/cusd-do-06.jpg",
            "/img/projects/cusd-do-01.jpg",
            "/img/projects/cusd-do-02.jpg",
            "/img/projects/cusd-do-05.jpg",
            "/img/projects/cusd-do-07.jpg",
            "/img/projects/cusd-do-08.jpg",
            "/img/projects/cusd-do-09.jpg",
            "/img/projects/cusd-do-10.jpg",
            "/img/projects/cusd-do-03.jpg",
            "/img/projects/cusd-do-04.jpg",
        ],
    },
    {
        id: "cusd-do-phase-2",
        name: "CUSD District Office — Phase 2",
        sector: "educational",
        sectorLabel: "Educational",
        partner: "Clovis Unified School District",
        architect: "Teter",
        sqft: "—",
        description: "Phase 2 of the CUSD District Office campus — fleet operations, maintenance & operations shops, construction services, and two-story administrative offices.",
        images: [
            "/img/projects/cusd-do2-08.jpg",
            "/img/projects/cusd-do2-05.jpg",
            "/img/projects/cusd-do2-06.jpg",
            "/img/projects/cusd-do2-09.jpg",
            "/img/projects/cusd-do2-07.jpg",
            "/img/projects/cusd-do2-10.jpg",
            "/img/projects/cusd-do2-01.jpg",
            "/img/projects/cusd-do2-02.jpg",
            "/img/projects/cusd-do2-03.jpg",
            "/img/projects/cusd-do2-04.jpg",
        ],
    },
    {
        id: "pom-wonderful-processing",
        name: "POM Wonderful Processing Entrance",
        sector: "industrial",
        sectorLabel: "Industrial",
        partner: "AP Engineering",
        architect: "—",
        sqft: "—",
        description: "Holding tank installation completed for POM Wonderful, supporting facility operations.",
        logoFit: true,
        images: [
            "/img/projects/pom-01-logo.png",
        ],
    },
    {
        id: "little-bear-solar",
        name: "Little Bear Solar Field Office",
        sector: "industrial",
        sectorLabel: "Industrial",
        partner: "Little Bear Holding Company, LLC",
        architect: "Cyrus Cowasjee Architects",
        sqft: "—",
        description: "Maintenance and support building constructed for the Little Bear Solar Field, providing a dedicated space to support daily operations and long-term facility needs.",
        images: [
            "/img/projects/littlebear-01.png",
        ],
    },
    {
        id: "raymond-fire-station",
        name: "Raymond Forest Fire Station",
        sector: "law-fire",
        sectorLabel: "Law Enforcement & Fire",
        partner: "Local Architectural Firm",
        architect: "—",
        sqft: "—",
        description: "Wildland response station with apparatus bays, crew quarters, and 24/7 operations infrastructure.",
        images: [
            "/img/projects/raymond-01.webp",
        ],
    },
    {
        id: "cusd-micare",
        name: "CUSD miCare Facility",
        sector: "medical",
        sectorLabel: "Medical",
        partner: "Clovis Unified School District",
        architect: "Darden",
        sqft: "—",
        description: "Employee medical office building completed for miCare, providing a dedicated and functional space for convenient on-site employee healthcare service.",
        images: [
            "/img/projects/micare-06-plc-entrance.webp",
            "/img/projects/micare-01-entrance.webp",
            "/img/projects/micare-02-waiting.webp",
            "/img/projects/micare-03-exam.webp",
            "/img/projects/micare-04-nurse.webp",
            "/img/projects/micare-05-nurse.webp",
            "/img/projects/micare-07-plc-break.webp",
            "/img/projects/micare-08-plc-corridor1.webp",
            "/img/projects/micare-09-plc-corridor2.webp",
            "/img/projects/micare-10-plc-meeting.webp",
        ],
    },
    {
        id: "porterville-wellness",
        name: "Porterville Wellness Center",
        sector: "medical",
        sectorLabel: "Medical",
        partner: "HMC Architects",
        architect: "—",
        sqft: "—",
        description: "Community wellness center expanding access to integrated health services in Tulare County.",
        images: [
            "/img/projects/porterville-01.webp",
        ],
    },
    {
        id: "cmc-wound-care",
        name: "CMC Wound Care",
        sector: "medical",
        sectorLabel: "Medical",
        partner: "Community Health System",
        architect: "—",
        sqft: "—",
        description: "Outpatient wound care clinic featuring dedicated exam rooms, staff work areas, hyperbaric oxygen therapy chambers, and a calm patient waiting area.",
        images: [
            "/img/projects/cmc-wound-care-01.webp",
            "/img/projects/cmc-wound-care-02.webp",
            "/img/projects/cmc-wound-care-03.webp",
            "/img/projects/cmc-wound-care-04.webp",
            "/img/projects/cmc-wound-care-05.webp",
            "/img/projects/cmc-wound-care-06.webp",
            "/img/projects/cmc-wound-care-07.webp",
            "/img/projects/cmc-wound-care-08.webp",
            "/img/projects/cmc-wound-care-09.webp",
            "/img/projects/cmc-wound-care-10.webp",
        ],
    },
    {
        id: "gibson-farm-market",
        name: "Gibson Farm Market",
        sector: "office-retail",
        sectorLabel: "Office & Retail",
        partner: "—",
        architect: "—",
        sqft: "—",
        description: "Farm market and retail facility featuring board-and-batten metal siding, a shaded entry canopy, and warm barn-style detailing that welcomes the community.",
        images: [
            "/img/projects/gibson-02.webp",
            "/img/projects/gibson-01.webp",
            "/img/projects/gibson-03.webp",
        ],
    },
    {
        id: "clovis-west-eecu",
        name: "Clovis West EECU",
        sector: "office-retail",
        sectorLabel: "Office & Retail",
        partner: "Education Employees Credit Union",
        architect: "—",
        sqft: "—",
        description: "On-campus credit union branch at Clovis West, combining a public banking floor with a training and meeting suite for financial literacy programs.",
        images: [
            "/img/projects/clovis-west-eecu-01.webp",
            "/img/projects/clovis-west-eecu-02.webp",
            "/img/projects/clovis-west-eecu-03.webp",
            "/img/projects/clovis-west-eecu-04.webp",
        ],
    },
    {
        id: "realty-concepts-clovis",
        name: "Realty Concepts - Clovis",
        sector: "office-retail",
        sectorLabel: "Office & Retail",
        partner: "Realty Concepts",
        architect: "Paul Halajian",
        sqft: "12,000 sq. ft.",
        description: "3 story 12,000 square foot structure housing Realty Concepts on the third floor, lending agency on the second floor and House of JuJu on the first floor.",
        images: [
            "/img/projects/realty-concepts-clovis-01.jpg",
        ],
    },
    {
        id: "fresno-fire-station-12",
        name: "Fresno Fire Station 12",
        sector: "law-fire",
        sectorLabel: "Law Enforcement & Fire",
        partner: "City of Fresno",
        architect: "—",
        sqft: "—",
        description: "Renovation and modernization of Fresno Fire Department Station No. 12 — supporting first responders with an updated, resilient facility serving the surrounding community.",
        images: [
            "/img/projects/fresno-fire-12-01.webp",
            "/img/projects/fresno-fire-12-02.webp",
        ],
    },
    {
        id: "clovis-veterans-heritage",
        name: "Clovis Veterans Heritage Center",
        sector: "nonprofit",
        sectorLabel: "Nonprofit",
        partner: "Clovis Veterans Memorial District",
        architect: "Darden",
        sqft: "—",
        description: "Community museum space honoring local veterans with immersive exhibits, gallery, and educational programs.",
        images: [
            "/img/projects/veterans-heritage-sign.webp",
            "/img/projects/veterans-exterior-eagle.webp",
            "/img/projects/veterans-exterior-worldmap.webp",
            "/img/projects/veterans-exterior-tribute.webp",
            "/img/projects/veterans-exterior-mideast.webp",
            "/img/projects/veterans-district-sign.webp",
            "/img/projects/veterans-interior-hall.webp",
            "/img/projects/veterans-interior-pacific.webp",
        ],
    },
    {
        id: "grace-church",
        name: "Grace Church of the Valley",
        sector: "religious",
        sectorLabel: "Religious",
        partner: "Grace Church of the Valley",
        architect: "The Taylor Group",
        sqft: "108,000 sq. ft.",
        description: "30,000 square foot church campus featuring a 1,200 seat worship space and 2 story classroom building.",
        images: [
            "/img/projects/grace-06.webp",
            "/img/projects/grace-07.webp",
            "/img/projects/grace-08.webp",
            "/img/projects/grace-09.webp",
            "/img/projects/grace-01.webp",
            "/img/projects/grace-02.webp",
            "/img/projects/grace-03.webp",
            "/img/projects/grace-04.webp",
            "/img/projects/grace-05.webp",
        ],
    },
    {
        id: "west-hills-cdc",
        name: "West Hills College Child Development Center",
        sector: "university",
        sectorLabel: "University & College",
        partner: "Darden Architects",
        architect: "—",
        sqft: "—",
        description: "Early-childhood learning center serving college students and the surrounding rural community.",
        images: [
            "/img/projects/westhills-01-cdc.png",
            "/img/projects/westhills-02-lrc.png",
        ],
    },
    {
        id: "boys-girls-club-renovation",
        name: "Boys & Girls Club Renovation",
        sector: "nonprofit",
        sectorLabel: "Nonprofit",
        partner: "Boys and Girls Clubs",
        architect: "Darden",
        sqft: "—",
        description: "Art classroom refurbishment for the Boys & Girls Club, creating an updated and functional space designed to support creativity, learning, and hands-on activities.",
        logoFit: true,
        images: [
            "/img/projects/bgc-01-logo.png",
        ],
    },
    {
        id: "citycenter-fresno-rescue-mission",
        name: "CityCenter — Fresno Rescue Mission",
        sector: "nonprofit",
        sectorLabel: "Nonprofit",
        partner: "Fresno Rescue Mission",
        architect: "The Taylor Group",
        sqft: "—",
        description: "3 Story remodel of a former hospital bringing together, under one roof, diverse specialists, non-profits, schools, and ministries to address barriers, burdens, and new beginnings, empowering individuals facing life insecurities.",
        images: [
            "/img/projects/citycenter-08.webp",
            "/img/projects/citycenter-06.webp",
            "/img/projects/citycenter-10.webp",
            "/img/projects/citycenter-09.webp",
            "/img/projects/citycenter-07.webp",
            "/img/projects/citycenter-05.webp",
            "/img/projects/citycenter-01.webp",
            "/img/projects/citycenter-02.webp",
            "/img/projects/citycenter-03.webp",
            "/img/projects/citycenter-04.webp",
        ],
    },
];

// Culture / events imagery for People & Culture page — first image is the featured/main
export const CULTURE_PHOTOS = [
    "/img/culture/culture-06-train.webp",
    "/img/culture/culture-01-group.jpg",
    "/img/culture/culture-08-christmas.webp",
    "/img/culture/culture-02-christmas.png",
    "/img/culture/culture-07-jersey.jpg",
    "/img/culture/culture-04-training.jpg",
    "/img/culture/culture-05-focus.webp",
];

export const HERO_IMAGE = "/img/mwc-hero.jpg";
export const TEXTURE_BG = "https://static.prod-images.emergentagent.com/jobs/59119a23-02e5-4597-b925-27b50e9b3f1c/images/e74d540ff25a57e45876057b4bb692644d3546214ae95b178e497775759ac3db.png";

export const LEADERSHIP = [
    {
        name: "Doug Reitz",
        title: "CEO",
        email: "doug@markwilsonconstruction.com",
        photo: "/img/team/doug.png",
    },
    {
        name: "Cole Bendoski",
        title: "President",
        email: "cole@markwilsonconstruction.com",
        photo: "/img/team/cole.png",
    },
    {
        name: "Joe Vasquez",
        title: "Vice President",
        email: "jvasquez@markwilsonconstruction.com",
        photo: "/img/team/joe.png",
    },
    {
        name: "Dawnette Rivas",
        title: "Director of Business Operations / HR",
        email: "dawnette@markwilsonconstruction.com",
        photo: "/img/team/dawnette.png",
    },
];


export const CLIENT_LOGOS = [
    "POM WONDERFUL", "STARBUCKS", "FIVE BELOW", "7-ELEVEN", "EECU",
    "FRESNO STATE", "CLOVIS USD", "WEST HILLS COLLEGE", "BOB'S FURNITURE",
];
